import { render, staticRenderFns } from "./updatePTLT.vue?vue&type=template&id=579bf2c2&lang=pug&"
import script from "./updatePTLT.vue?vue&type=script&lang=js&"
export * from "./updatePTLT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports